export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/30">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }}
              className="flex items-center gap-2 mb-4 cursor-pointer"
            >
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-global-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-heading font-bold text-foreground-100">在线吃瓜</span>
            </a>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
              在线吃瓜品牌入口导航平台，汇集91在线吃瓜网、线路一、网站等官方及最新入口地址。
              提供备用网址与官方线路，确保用户快速访问在线吃瓜内容，不迷路。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '最新快讯', href: '#updates' },
                { label: '入口热度榜', href: '#ranking' },
                { label: '主题索引', href: '#index' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                  className="text-xs md:text-sm text-foreground-500 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">服务支持</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '关于我们', href: '#about' },
                { label: '联系我们', href: '#contact' },
                { label: '媒体聚焦', href: '#media' },
                { label: '吃瓜精选', href: '#cards' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                  className="text-xs md:text-sm text-foreground-500 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-600 leading-relaxed">
              在线吃瓜入口导航平台持续拓展合作网络，为更多用户提供稳定可靠的吃瓜通道服务。
            </p>
          </div>
        </div>

        <div className="border-t border-background-300/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 在线吃瓜 · 访问在线吃瓜不迷路，一键收藏
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">首页</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollTo('#about'); }} className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">关于</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }} className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">FAQ</a>
          </div>
        </div>
      </div>
    </footer>
  );
}